<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="loco-problems-wrapper">
	<div *ngFor="let incident of listOfIncident | locoProblemSort;let i=index">
		<div class='{{getIncidentClass(incident.incidentType, incident.incidentCode)}} notification' *ngIf='i<shownList'>
			<ul>
				<li class="alert-icon"></li>
				<li><b>{{incident.incidentCode|locoBlankString}}</b></li>
				<li><b>{{incident.incidentDate|locoBlankString}}</b></li>
				<li *ngIf='incident.incidentType==="O"'>
					<b>
            <span class="problem-type" *ngIf='incident.partialPower==="Y"'>{{locoLabel.partialPower}}</span>
            <span class="problem-type" *ngIf='incident.trailUseOnly==="Y"'>{{locoLabel.trailOnly}}</span>
            <span class="problem-type" *ngIf='incident.workToShop==="Y"'>{{locoLabel.toShop}}</span>
			<span class="problem-type" *ngIf='incident.partialPower==="N" && incident.trailUseOnly==="N" && incident.workToShop==="N"'>Other</span>
            </b>
				</li>
				<li *ngIf='incident.incidentType==="D"'><b>{{locoLabel.dead}}</b></li>
				<li><b>{{incident.incidentDescription|locoBlankString}}</b></li>
				<li><b>{{incident.dispatcherRemarks|locoBlankString}}</b></li>
			</ul>
		</div>
	</div>
	<div *ngIf="listOfIncident?.length===0" class="green-problem notification">
		<ul>
			<li class="alert-icon"></li>
			<li class="no-problem-msg-text"><b>{{locoLabel.noError}}</b></li>
		</ul>
	</div>
	<a href="javascript:void(0)" *ngIf='shownList>3' (click)='showLessList()' class="show-less-data">{{locoLabel.showLess}} ({{listOfIncident?.length-3}})</a>
	<a href="javascript:void(0)" *ngIf='shownList===3 && listOfIncident?.length>3' (click)='showMoreList()' class="show-more-data">{{locoLabel.showMore}} ({{listOfIncident?.length-3}})</a>
</div>
<div class="clear"></div>